import React from "react";
import "./card-footer.scss";

function CardFooter(props) {
  return <div className="callout-flex-footer">{props.children}</div>;
}

export default CardFooter;
